/** basic.fireFightingPlatform */
export default {
    fire_title: "Система умного пожаротушения",
    fire_VideoTItle: "Платформа видеонаблюдения (старая версия)",
    fire_VideoTItle_GB: "Платформа видеонаблюдения (гос. стандарт)",
    fire_VideoTItle_MQTT: "Платформа видеонаблюдения (MQTT)",
    fire_basicData: "Базовые данные",
    fire_alarmData: "Данные предупреждений",
    fire_account: "Управление учётными записями",
    fir_map: "Карта предупреждений",

    left_alarmRecords: "Записи тревог",
    left_faultRecords: "Записи неисправностей",
    left_deviceManage: "Управление устройствами",
    left_siteUnit: "Объект/здание",
    left_floorList: "Список этажей",
    left_installPointManage: "Управление точками установки",
    left_patrolTask: "Задачи инспекции",
    left_patrolRecords: "Записи инспекции",
    left_dangerRecords: "Записи нарушений",
    left_patrolState: "Состояние нарушений",
    left_patrolType: "Тип нарушения",
    left_entityManage: "Управление организациями",
    left_userManage: "Управление пользователями",
    left_deviceStatistics: "Статистика устройств",
    left_alarmStatistics: "Статистика тревог",
    left_faultStatistics: "Статистика неисправностей",
    left_patrolTrouble: "Нарушения/инспекция",
    left_devcieStateStatistics: "Статистика состояния устройств",
    left_troubleSatistics: "Статистика нарушений",
    left_installStatistics: "Статистика установок",
    left_patrolStatistics: "Статистика инспекций",

    map_deviceDetails: "Детали устройства",
    map_runData: "Рабочие данные",
    map_orderTips: "Выполнить эту команду?",
    map_Controls: "Действия",
    map_signal: "Уровень сигнала",
    map_voltage: "Напряжение",
    map_temperature: "Температура",
    map_concentration: "Концентрация",
    map_installTime: "Время установки",
    map_noOrder: "У устройства нет команд для отправки",

    map_floorNum: "Количество этажей",
    map_installPoint: "Количество точек",
    map_go: "Перейти",

    Gas_title: "Система газовой безопасности",
    PRoduction_title: "Система управления производством",
    patrol_title: "Система инспекции и патрулирования",
    patrol_taskType: "Тип задачи",
    patrol_checkstate: "Результат проверки",
    patrol_type: "Тип аномалии",
    map_deviceModelNum: "Модель устройства",
    Production_deviceModel: "Модель устройства",
    Production_modelNum: "Команда модели",
    Production_PatrolRes: "Записи проверки качества",
    Production_devicePatrol: "Проверка устройств",
    Production_deviceImport: "Импорт устройств",
    Production_zuce: "Записи регистрации",
    Production_zuxiao: "Записи деактивации",
}
